module.exports = __webpack_public_path__ + "assets/img/thumb-NuMobile-Brand-Video.dc1ca4b2.webp";